import { RoutingUtilitiesService } from '../_services/routingUtlities.service';

let _loaderService: RoutingUtilitiesService | null = null;

export function setRoutingLoaderService(service: RoutingUtilitiesService) {
  _loaderService = service;
}
